import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Document, IDocument } from "src/app/interfaces";

@Component({
    selector: "circ-document-card",
    templateUrl: "./document-card.component.html",
    styleUrls: ["./document-card.component.scss"],
    standalone: false
})
export class DocumentCardComponent {
  @Input()
  public document: Document;
  @Output()
  public documentDelete = new EventEmitter<IDocument>();
  @Output()
  public documentOpen = new EventEmitter<IDocument>();
  @Output()
  public documentDownload = new EventEmitter<IDocument>();

  public onDeleteDocument(): void {
    this.documentDelete.emit(this.document.doc);
  }

  public onDownloadDocument(): void {
    this.documentDownload.emit(this.document.doc);
  }

  public onOpenDocument(): void {
    this.documentOpen.emit(this.document.doc);
  }
}
